import { AavoDialog } from "src/components/common/dialogs/AavoDialog.tsx";
import type { AavoDialogProps } from "src/components/common/dialogs/AavoDialog.tsx";
import i18n from "i18next";
import { ErrorView } from "src/components/common/errors/ErrorView.tsx";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { OpenErrorReportDialogButton } from "src/sentry/OpenErrorReportDialogButton";
import { LoggedError } from "src/errorHandling/errorLogging.ts";
import { SolveErrorWithAiButton } from "src/components/common/errors/SolveErrorWithAiButton.tsx";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface ErrorDialogProps extends Omit<AavoDialogProps, "title" | "actions" | "content" | "open" | "onClose"> {
	error: LoggedError;
	closeDialog: () => void;
	disableCustomizedErrorViews?: boolean;
}

export const ErrorDialog = ({
	error,
	size = "sm",
	disableCustomizedErrorViews,
	closeDialog,
	...other
}: ErrorDialogProps) => {
	return (
		<AavoDialog
			onClose={closeDialog}
			size={size}
			title={i18n.t("error")}
			actions={
				<>
					<SolveErrorWithAiButton />
					{error.treatAsError && error.sentryEventId && (
						<OpenErrorReportDialogButton
							eventId={error.sentryEventId}
							onClick={() => {
								closeDialog();
							}}
						/>
					)}
					{/* Use raw buttons in ErrorDialog. AsyncButton/AavoButton depend on ErrorDialogContext. */}
					<Button
						variant={"contained"}
						startIcon={<FontAwesomeIcon icon={faCheck} />}
						sx={{ textTransform: "none" }}
						onClick={() => {
							closeDialog();
						}}
					>
						{i18n.t("close")}
					</Button>
				</>
			}
			{...other}
		>
			<ErrorView
				sx={{
					padding: 1,
				}}
				error={error}
				showReportButton={false}
				showSolveWithAiButton={false}
				disableCustomizedErrorViews={disableCustomizedErrorViews}
			/>
		</AavoDialog>
	);
};
